import { LoaderFunctionArgs, LoaderFunction } from 'react-router-dom'
import { toast } from 'react-toastify'

import { sponsorshipApi } from '../../../services/sponsorship'
import type { AppStore } from '../../../store'
import { SponsorshipType } from '../../../types'
import i18n from '../../../i18n'

export const mySponsorshipLoader = (store: AppStore) =>
  (async ({ params }: LoaderFunctionArgs) => {
    const { eventId } = params
    const id = Number.isNaN(Number(eventId)) ? undefined : Number(eventId)

    if (!id) {
      throw new Error('Event id is required')
    }

    const data = await store.dispatch(
      sponsorshipApi.endpoints.mySponsorship.initiate(undefined, { forceRefetch: true })
    )

    if (data && !!data.data) {
      return data.data
    }

    toast.error(
      i18n.t(
        "Aucune demande de sponsoring trouvée pour cet événement. Veuillez contacter l'organisateur si vous pensez qu'il s'agit d'une erreur."
      )
    )
    return {} as SponsorshipType
  }) satisfies LoaderFunction
